var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{class:{disabled: _vm.disable}},[_c('a',{staticClass:"menuItem",on:{"click":_vm.click}},[_c('span',{staticClass:"menuLabel"},[_c('div',{staticClass:"flex col-grow no-wrap justify-between"},[_c('span',{staticClass:"menu-label-content"},[_vm._v(_vm._s(_vm.label))]),_c('span',{staticClass:"shortcut"},[_vm._v(_vm._s(_vm.shortcut))])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }